// Hell/Dunkel für den Immobilienbereich (README §10).
// localStorage['immo-theme'] = 'light' | 'dark', gesetzt über data-theme auf <html>.
// index.html setzt den Wert schon vor dem ersten Rendern mit derselben Regel.

import { useSyncExternalStore } from 'react';

export type ImmoTheme = 'light' | 'dark';

export const THEME_SCHLUESSEL = 'immo-theme';
const EREIGNIS = 'immo-theme-change';

/** Nur 'dark' gilt als dunkel – alles andere (auch kaputte Werte) ist hell. */
export function normalisiereTheme(wert: string | null | undefined): ImmoTheme {
  return wert === 'dark' ? 'dark' : 'light';
}

export function leseTheme(): ImmoTheme {
  if (typeof document !== 'undefined') {
    const gesetzt = document.documentElement.dataset.theme;
    if (gesetzt === 'dark' || gesetzt === 'light') return gesetzt;
  }
  try {
    return normalisiereTheme(localStorage.getItem(THEME_SCHLUESSEL));
  } catch {
    return 'light';
  }
}

export function setzeTheme(theme: ImmoTheme): void {
  try {
    localStorage.setItem(THEME_SCHLUESSEL, theme);
  } catch {
    // privater Modus o. ä.: Theme gilt dann nur für diese Sitzung
  }
  document.documentElement.dataset.theme = theme;
  window.dispatchEvent(new Event(EREIGNIS));
}

function abonniere(rueckruf: () => void): () => void {
  window.addEventListener(EREIGNIS, rueckruf);
  window.addEventListener('storage', rueckruf);
  return () => {
    window.removeEventListener(EREIGNIS, rueckruf);
    window.removeEventListener('storage', rueckruf);
  };
}

/** Aktuelles Theme + Setter; alle Nutzer bleiben synchron (auch über Tabs). */
export function useImmoTheme(): [ImmoTheme, (t: ImmoTheme) => void] {
  const theme = useSyncExternalStore(abonniere, leseTheme, (): ImmoTheme => 'light');
  return [theme, setzeTheme];
}
